import api from './api';

// Kept out of lib/api.js deliberately, same posture as
// adminReceiptPaidTraceApi.js: this is the only call site this card needs,
// and lib/api/*.js domain files are edited concurrently by other sessions.
// Reuses api's shared axios instance (baseURL, auth interceptor) unchanged.
//
// Out-of-band (202 + job id, JobStore-backed -- same shape as the
// Receipt-Paid trace card). Keyed by transaction_id so tracing two
// different Wise transactions never collides on "already running".
export const adminWiseSupplierTraceAPI = {
  traceStart: (transactionId) =>
    api.post('/admin/diagnostics/wise-supplier-trace/start', { transaction_id: transactionId }),
  traceJobStatus: (jobId) => api.get(`/admin/diagnostics/wise-supplier-trace/job-status/${jobId}`),
  traceJobLatest: (transactionId) =>
    api.get('/admin/diagnostics/wise-supplier-trace/job-latest', { params: { transaction_id: transactionId } }),
};
